import { render, staticRenderFns } from "./button_pagination.vue?vue&type=template&id=4941673d&scoped=true&"
import script from "./button_pagination.vue?vue&type=script&lang=js&"
export * from "./button_pagination.vue?vue&type=script&lang=js&"
import style0 from "./button_pagination.vue?vue&type=style&index=0&id=4941673d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4941673d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4941673d')) {
      api.createRecord('4941673d', component.options)
    } else {
      api.reload('4941673d', component.options)
    }
    module.hot.accept("./button_pagination.vue?vue&type=template&id=4941673d&scoped=true&", function () {
      api.rerender('4941673d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/widgets/button_pagination.vue"
export default component.exports